import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

// eslint-disable-next-line import/no-unused-modules
export const ContactBox = styled.div`
  background-color: ${colorPalette.mouseGrey};
  border: none;

  @media (max-width: 979px) {
    width: 100%;
  }

  &,
  *:not(i) {
    font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  }
`;
